import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import image1 from '../../images/testimonial/1.jpg';
import image2 from '../../images/testimonial/2.jpg';
import image3 from '../../images/testimonial/3.jpg';

import Shape1 from "../../images/testimonial/star.svg";
import Shape2 from "../../images/testimonial/star-1.svg";
import Shape3 from "../../images/testimonial/quote.png";

import person1 from "../../images/faxian-it-images/person1.webp"
import person2 from "../../images/faxian-it-images/person2.webp"

const TestimonialData = [
    {
        id: "01",
        text: "FaxianIT guided us through a complex cloud migration with zero downtime. Their team’s expertise is unmatched.",
        subtitle: "CTO, Global Logistics",
        title: "Michael A",
        image: person1
    },
    {
        id: "02",
        text: " The consultants at FaxianIT really understand business challenges. Their IT strategy helped us scale faster than expected.",
        subtitle: "COO, RetailNext",
        title: "Priya M.",
        image: person2
    },
    {
        id: "03",
        text: "From Salesforce implementation to ongoing support, FaxianIT has been a reliable partner every step of the way.",
        subtitle: "VP of Sales, Healthcare Innovators",
        title: "Sarah J",
        image: person1
    },
    {
        id: "04",
        text: "We’ve worked with many vendors, but FaxianIT stands out for professionalism, responsiveness, and technical excellence.",
        subtitle: "Director of IT, Fintech Solutions",
        title: "David C",
        image: person2
    },


]



const TestimonialSection = () => {
    const ClickHandlar = () => {
        window.scrollTo(10, 0);
    }

    const settings = {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        infinite: true,
        responsive: [{
            breakpoint: 1199,
            settings: {
                dots: true,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                dots: true,
            }
        },

        ]
    };
    return (
        <section className="testimonial-section  contact-bg py-5">
            <div className="container">
                <div className="row align-content-center align-items-center py-5">
                    <div className="col-xl-4 col-12 ">
                        <div className="section-title">
                            <span>Testimonial</span>
                            <h2  style={{color:'#FBB132'}}>What Our Clients Say</h2>
                            <p className='text-white'>Building lasting partnerships through trust and innovation. </p>
                            {/* <div className="testimonial-btn">
                                <Link to="" className="theme-btn" onClick={ClickHandlar}> Get in Touch <i className="ti-arrow-right"></i></Link>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-8 col-12">
                        <div className="testimonial-slider">
                            <Slider {...settings}>
                                {TestimonialData.map((Testimonials, tky) => (
                                    <div className="item" key={tky}>
                                        <div className="client">
                                            <div className="image">
                                                <img src={Testimonials.image} alt="" />
                                            </div>
                                            <div className="text">
                                                <h2>{Testimonials.title}</h2>
                                                <span>{Testimonials.subtitle}</span>
                                            </div>
                                        </div>
                                        <div className="reting">
                                            <ul>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                {/* <li><img src={Shape2} alt="" /></li> */}
                                            </ul>
                                            <span>(5.0)</span>
                                        </div>
                                        <p>{Testimonials.text}</p>
                                        <div className="icon">
                                            <img src={Shape3} alt="" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TestimonialSection







